<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        <section slot="filters">
            <gz-select-container 
                label="Проверки по типу объекта"
                type="filter"
                class="gz-input-container_default gz-select_default"
                :dataList="filterCheckupTypes"
                @selectedItem="filter = $event"   
            >
                <GZ-TextInput
                    :importedData="filter.name"
                    :readonly="true"
                    :selectType="true"
                    @input="getCheckups()"
                />
            </gz-select-container>
        </section>
        
        <section slot="content">
            <span v-if="checkupsComputed.length < 1" style="font-size: .9rem">Нет проверок этого типа для данного сотрудника</span>
            <!-- <CheckupRow 
                v-for="(items, index) in checkupsComputed"
                :key="index"
                :items="items"
                :isStaff="true"
            /> -->
        </section>        

    </gz-auth-view-template>
</template>

<script>
// import CheckupRow from '@/components/custom/admin/views/addresses/BaseCheckupRow'

export default {
    name: 'StaffSingleCheckups',

    components: {
        // CheckupRow
    },
    data() {
        return {
            checkups: [],
            filter: {name: 'здания', type: 'building'},
            filterCheckupTypes: [
                {name: 'здания', type: 'building'},
                {name: 'помещения', type: 'property'}
            ]
        }
    },
    computed: {
        dataComputed() {
            return this.$store.getters['staffUser']
        },
        checkupsComputed() {
            return this.checkups
        }
    },
    mounted() {
        this.getCheckupsBuilding()
    },
    methods: {
        getCheckupsBuilding() {
            this.$axios({
                method: 'GET',
                url: 'checkup/building',
                params: {
                    verifiedByUid: this.$route.params.id,
                    buildingId: '*',
                    pg: 0,
                    batch: 20
                }
            })
            .then(({data}) => {
                this.checkups = data.data
            })
            .catch(err => {
                console.error('Ошибка получения проверок: ', err)
            })
        },
        getCheckupsProperty() {
            this.$axios({
                method: 'GET',
                url: 'checkup/property',
                params: {
                    verifiedByUid: this.$route.params.id,
                    propertyId: '*',
                    pg: 0,
                    batch: 20
                }
            })
            .then(({data}) => {
                this.checkups = data.data
            })
            .catch(err => {
                console.error('Ошибка получения проверок: ', err)
            })
        }
    },
    watch: {
        filter: {
            handler(newVal) {
                if (newVal.type === 'building') {
                    this.checkups = []
                    this.getCheckupsBuilding()
                } 
                if (newVal.type === 'property') {
                    this.checkups = []
                    this.getCheckupsProperty()
                }
            },
            deep: true
        }
    }
}
</script>